import { css } from '@bts-web/utils-style-engine';
import { ReactNode } from 'react';

export function EntryRightIcon({ icon }: { icon: ReactNode }) {
  return (
    <div
      className={css({
        p: 'extra_small_2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginInlineStart: 'auto',
      })}
    >
      {icon}
    </div>
  );
}
